import _ from 'lodash';
import ChargeV2Templates from '@wix/wixrest-utils/dist/openrest-helpers/ChargeV2Templates';
import JsonTemplates from '@wix/wixrest-utils/dist/JsonTemplates';
import OPU from '@wix/wixrest-utils/dist/Properties';
import { DiscountUnits } from './constants';

export function isManagerDiscount(charge) {
  try {
    const properties = JSON.parse(charge.properties['com.wix.restaurants']);
    return properties.isManagerDiscount;
  } catch (e) {
    return false;
  }
}

function getRelevantItemIdsFromRawManagerDiscount(charge) {
  return charge.operator.operators[0].numerators[0].items.ids;
}

function fixRelevantItemIdsByTaxGroup(operator, charge, discountUnit) {
  const result = JSON.parse(JSON.stringify(operator));
  const taxGroupItemIds = getRelevantItemIdsFromRawManagerDiscount(charge);
  result.operators[0].numerators[0].items.type = 'include';
  result.operators[0].numerators[0].items.ids = taxGroupItemIds;

  if (discountUnit === DiscountUnits.CURRENCY) {
    result.operators[1].denominators[0].denominators[0].items.type = 'include';
    result.operators[1].denominators[0].denominators[0].items.ids = taxGroupItemIds;
  }

  return result;
}

function createAmountOperator(charge, amount) {
  const applyTo = { type: 'exclude', ids: [] };
  const template = ChargeV2Templates.fixedOneTimeDiscount;
  const params = { applyTo, amount };
  const { operator } = JSON.parse(JSON.stringify(JsonTemplates.fillTemplate({ template, params })));
  return fixRelevantItemIdsByTaxGroup(operator, charge, DiscountUnits.CURRENCY);
}

function createPercentOperator(charge, percent) {
  const applyTo = { type: 'exclude', ids: [] };
  const template = ChargeV2Templates.percentDiscount;
  const params = { applyTo, percent };
  const { operator } = JSON.parse(JSON.stringify(JsonTemplates.fillTemplate({ template, params })));
  return fixRelevantItemIdsByTaxGroup(operator, charge, DiscountUnits.PERCENT);
}

function applyOperatorToManagerDiscount({ charge, amount, discountUnit }) {
  const operator =
    discountUnit === DiscountUnits.CURRENCY
      ? createAmountOperator(charge, amount)
      : createPercentOperator(charge, amount);

  const result = {
    ...charge,
    operator,
  };

  const managerDiscountType = discountUnit === DiscountUnits.CURRENCY ? 'fixedOneTimeDiscount' : 'percentDiscount';

  OPU.set(result, 'managerDiscountType', managerDiscountType);

  return result;
}

export function getManagerDiscounts({ chargesV2 = [] } = {}) {
  return chargesV2.filter(isManagerDiscount);
}

export function removeManagerDiscounts({ chargesV2 = [] } = {}) {
  return chargesV2.filter(charge => !isManagerDiscount(charge));
}

export function applyOperatorsToManagerDiscounts({ chargesV2, amount, discountUnit }) {
  const clonedChargesV2 = _.cloneDeep(chargesV2);
  const managerDiscounts = getManagerDiscounts({ chargesV2: clonedChargesV2 });
  const otherCharges = removeManagerDiscounts({ chargesV2: clonedChargesV2 });
  const managerDiscountsWithValue = managerDiscounts.map(charge =>
    applyOperatorToManagerDiscount({ charge, amount, discountUnit }),
  );
  return [...otherCharges, ...managerDiscountsWithValue];
}
